export default function Link({ text, href, rel = "", target = "" }: any) {
  return (
    <a
      href={href}
      rel={rel}
      target={target}
      style={{
        color: "#0000EE",
        textDecoration: "underline",
      }}
    >
      {text}
    </a>
  );
}
